import React from 'react';
import styled from 'styled-components';
import HS from '../assets/HS.svg';
import LogoSVG from '../assets/HSLogo.svg';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    gap: 0.1em
`;

const LogoText = styled.div`
    background-color: ${({ theme }) => theme.text};
    -webkit-mask: url(${HS}) no-repeat center;
    mask: url(${HS}) no-repeat center;
    width: 100%;
    display: flex;
    align-items: center;
`;

const LogoCSS = styled.div`
    background-image: url(${LogoSVG});
    position: relative;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 3em;
`;

const Logo = ({ text = false, ...props }) => {
    return (
        <Wrapper>
            {
                text ?
                    <>
                        <LogoCSS alt='HSLogo' />
                        <LogoText alt='HSLogoText' />
                    </>
                    : <LogoCSS alt='HSLogo' />
            }
        </Wrapper>
    );
}

export default Logo;
